<h6 class="loginHeadingText text-start pt-3 mb-2 mt-2">FUNDING AND RMS</h6>
<div class="row mb-15px">
    <div class="col-md-4 align-self-center ">
    <label for="">FUNDING TYPE</label>
    </div>
    <div class="col-md-8">
        <select class="form-select" aria-label="Default select example"
            (change)="onFundingTypeChange()"
            [(ngModel)]="selectedFundingRMS!.fundingType!"
            (ngModelChange)="onAnyFieldValueChange($event)" >
            <option selected="" value="0">Select Funding Type</option>
            <option *ngFor="let ft of fundingTypes" [disabled]="ft.disabled"
                [value]="ft.id">{{ ft.name }}</option>
          </select>
    </div>
</div>

<div class="row mb-15px">
    <div class="col-md-4 align-self-center mb-1">
    <label for="">ISO REVIEWED</label>
    </div>
    <div class="col-md-1 activityType align-self-center">
    
    <!-- (change)="onSreReviewChange();" -->
    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
        [disabled]="!isSreCheckboxEnabled" (ngModelChange)="onAnyFieldValueChange($event)"
        [(ngModel)]="selectedFundingRMS!.sreReviewed">
    </div>
    <div class="col-md-5 activityType">
    
        <select class="form-select" aria-label="Default select example"
        [disabled]="!sreDropdownEnabled"
        [(ngModel)]="selectedFundingRMS!.reviewedBy!" (ngModelChange)="onAnyFieldValueChange($event)"
        (change)="onSpocChange($event)">
        <option selected="" value="0">Select SPOC</option>
        <option *ngFor="let item of sreUsers" [value]="item.userID">
            {{ item.firstname + " " +  item.lastname}}
        </option>
    </select>
    </div>
</div>

<!-- <div class="row mb-15px">
    <div class="col-md-4 align-self-center ">
    <label for="">REVIEWED BY</label>
    </div>
    <div class="col-md-4 activityType">
        
    </div>
    <div class="col-md-4 activityType">
        <app-flexible-file-upload [inputFIleID]="fundRMSJTBDFileName"
            [disableControl]="!sreFileUploadEnabled"
            [selectedFiles]="selSREFileUpload"
            [acceptedFileTypes]="'*/*'"
            [showAdditionalInfo]="false"
            [allowMultipleFiles]="false"
            (fileUploaded)="handleSREFileUpload($event);">
        </app-flexible-file-upload>
    </div>
</div> -->

<div class="row mb-15px">
    <div class="col-md-4 align-self-center ">
    <label for="">CMF PROMO</label>
    </div>
    <div class="col-md-8 activityType">
    <input type="text" class="form-control" maxlength="50" (ngModelChange)="onAnyFieldValueChange($event)"
        [disabled]="!cmfPromoEnabled"
        [(ngModel)]="selectedFundingRMS!.cmfPromo"
        (change)="onCMFPromoChange()">
    </div>
</div>


<div class="row mb-15px">
    <div class="col-md-4 align-self-center ">
    <label for="">TACTIC ID</label>
    </div>
    <div class="col-md-8 activityType">
    <input type="text" class="form-control"  maxlength="50"
        [disabled]="!cmfTacticEnabled"
        [(ngModel)]="selectedFundingRMS!.cmfTactIcID" (ngModelChange)="onAnyFieldValueChange($event)"
        (change)="onCMFTacticIdChange()">
    </div>
</div>

<div class="row mb-15px">
    <div class="col-md-4 align-self-center ">
    <label for="">ESTIMATED COST</label>
    </div>
    <div class="col-md-8 activityType">
    <!-- <input type="number" class="form-control" 
        [disabled]="!estimatedCostEnabled"
        [(ngModel)]="selectedFundingRMS!.estimatedCost"
        (input)="onInputChange($event)"
        (keydown)="onKeyDownEstimatedCost($event)"
        (change)="onCostChange()"> -->
        <input type="text" class="form-control"
       [disabled]="!estimatedCostEnabled"
       [value]="selectedFundingRMS?.estimatedCost !== null && selectedFundingRMS?.estimatedCost !== undefined 
                    ? formatCurrency(selectedFundingRMS?.estimatedCost) 
                    : ''"
       (input)="onInputChange($event)"
       (keydown)="onKeyDownEstimatedCost($event)"
       (change)="onCostChange()">

        
    </div>
</div>

<div class="row mb-15px">
    <div class="col-md-4 align-self-center ">
    <label for="">CATEGORY APPROVAL EMAIL</label>
    </div>
    <div class="col-md-8 activityType">
    <!-- <div class="input-group custom-file-button" style="padding-left: 2px;">
        <input type="file" class="form-control" id="inputGroupFile">
        <label class="input-group-text" for="inputGroupFile">UPLOAD</label>
    </div> -->

    <div class="input-group custom-file-button" style="padding-left: 2px;">
        <app-flexible-file-upload [inputFIleID]="fundRMSCategoryFileName"
            [disableControl]="!approvalEmailEnabled"
            [selectedFiles]="selectedFiles"
            [disableAfterReview]="disableFields"
            [acceptedFileTypes]="'*/*'"
            [showAdditionalInfo]="false"
            [allowMultipleFiles]="false"
            (fileUploaded)="handleCategoryFileUpload($event);">
        </app-flexible-file-upload>
    </div>
    </div>
</div>

<!-- <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-8">
    <div class="row">
        <div class="col-md-1">
        <img src="assets/images/close_mark.svg" alt="">
        </div>
        <div class="col-md-7 ps-0">
        <a href="#" class="fw-bold" style="color:#0c9ef1; text-decoration: none;">
            Approval_for_Category.eml
        </a>
        </div>
        <div class="col-md-3 text-end">
            <p class="mb-0">(3590)</p>
        </div>
    </div>
    </div>

</div> -->